// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"746194bf","169":"9273cbe4","351":"271405d3","378":"0c852e0b","530":"a068cd76","676":"3b634a37","737":"abfe2a7c","780":"7cca32f5","841":"8057c832","842":"1cac5f23","849":"fee5ab0f"}[chunkId] + ".chunk.js";
};